import { render } from "./users.vue?vue&type=template&id=e87aa9e6"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"

import "./users.vue?vue&type=style&index=0&id=e87aa9e6&lang=css"
script.render = render

export default script